import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    data: '1235464878',
    logoUrl:''
  },
  mutations: {
    setdata() {
      this.state.data++;
    },
    setLogoUrl(state,newLogoUrl){
      state.logoUrl = newLogoUrl
    }
  },
  actions: {
  },
});
